/* eslint-disable vue/multi-word-component-names */
import Vue from 'vue'
import SideContent from '@ui/SideContent'
import ListItem from '@ui/ListItem'
import Loading from '@ui/Loading.vue'
import TitleValue from '@ui/TitleValue'
import GlobalToolbar from '@ui/GlobalToolbar'
import DownloadFile from '@ui/DownloadFile'
import HelpTooltip from '@ui/HelpTooltip'

Vue.component('side-content', SideContent)
Vue.component('list-item', ListItem)
Vue.component('title-value', TitleValue)
Vue.component('loading', Loading)
Vue.component('global-toolbar', GlobalToolbar)
Vue.component('download-file', DownloadFile)
Vue.component('help-tooltip', HelpTooltip)
